module.exports = __webpack_public_path__ + "0ac9ef7170a22c1902900177ca1bfb2a.svg";